let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9nSAL")).then(() => parcelRequire('bTqVl'));